// extracted by mini-css-extract-plugin
export default {"arrow":"WaysToWearItCarousel___WaysToWearItCarousel-module__arrow___etFdS","blockClicks":"WaysToWearItCarousel___WaysToWearItCarousel-module__blockClicks___jNAfj"};